import { render, staticRenderFns } from "./loadingCartonTopallet.vue?vue&type=template&id=4ff36eb0&"
import script from "./loadingCartonTopallet.vue?vue&type=script&lang=js&"
export * from "./loadingCartonTopallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports